import { AUMS_GET } from '../actions/types';

const initialState = {
  items: undefined,
  map: undefined,
  accounts: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AUMS_GET._SUCCESS: {
      const { aums } = action.payload;
      state.items = Object.values(aums);
      state.map = aums;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as aums };
